import { Component, Input, OnInit } from '@angular/core';
import { Product } from '../../../../../models/Product';

@Component({
  selector: 'app-ape-active',
  templateUrl: './ape-active.component.html',
  styleUrls: ['./ape-active.component.scss']
})
export class ApeActiveComponent implements OnInit {
  @Input('product') product?: Product; //assigned a COPY so that original is maintained to check diff.
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/admin-products/admin-product-edit/ape-active/ape-active.component.ts